import store from "@/store";
// import router from "@/router";

export default function(to, from, next) {
  store.dispatch("clearValidationErrors");
  next();
}
